import { render } from "./system.vue?vue&type=template&id=1b90c0c3&scoped=true"
import script from "./system.vue?vue&type=script&lang=js"
export * from "./system.vue?vue&type=script&lang=js"

import "./system.vue?vue&type=style&index=0&id=1b90c0c3&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b90c0c3"]])

export default __exports__